import { render, staticRenderFns } from "./ViewDynamicProductsTable.vue?vue&type=template&id=5f3c0608&scoped=true&"
import script from "./ViewDynamicProductsTable.vue?vue&type=script&lang=js&"
export * from "./ViewDynamicProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./ViewDynamicProductsTable.vue?vue&type=style&index=0&id=5f3c0608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c0608",
  null
  
)

export default component.exports